@if (message) {
  <div class="flex align-items-center">
    <div>
      {{message.date | date: 'mediumDate'}}
    </div>
    <div class="flex-1"></div>
    <div></div>
  </div>
  <p-divider/>
  <div>
    {{message.subject}}
  </div>
  <p-divider/>
  <div [innerHTML]="message.text">
  </div>
  @if (message.link) {
    <div class="pt-2">
      <p-button icon="pi pi-external-link" styleClass="p-button-text" (onClick)="openLink(message.link)"
                [label]="'GOTO_TOURNAMENT' | translate"/>
    </div>
  }
}
